import React from 'react'
import PropTypes from 'prop-types'
import { OnboardingPrompt, Modal } from 'components/UIElements'
import '../stylesheets/Announcements.scss'
import AnnouncementsList from './AnnouncementsList'
import BlockingConsentModal from '../../Consent/components/BlockingConsentModal'

class AnnouncementsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: [],
      onboarded: false
    }
  }

  componentDidMount() {
    const { fetchInstruments, announcements, strings } = this.props
    if (announcements.length === 0) {
      fetchInstruments(strings)
    }
  }

  close = () => {
    this.setState({ onboarded: true })
  }

  render() {
    const {
      onboarding,
      strings,
      loading,
      announcementsInstances,
      unreadAnnouncements,
      onAnnouncementRead,
      sendEvent,
      sendAnnouncementsSeen,
      humiIsabellaDisabled,
      showConsentModal
    } = this.props
    const { onboarded } = this.state

    return (
      <div className='announcements page'>
        <BlockingConsentModal
          showConsentModal={showConsentModal}
          strings={strings}
        />
        {!showConsentModal && (
          <>
            <p>{strings.navbar_inbox}</p>
            <div className='linkt-container'>
              {onboarding && !onboarded && (
                <OnboardingPrompt
                  type='announcements'
                  closeFunc={this.close}
                  strings={strings}
                  humiIsabellaDisabled={humiIsabellaDisabled}
                />
              )}
              <AnnouncementsList
                loading={loading}
                announcements={announcementsInstances}
                strings={strings}
                unreadAnnouncements={unreadAnnouncements}
                onAnnouncementRead={onAnnouncementRead}
                sendEvent={sendEvent}
                sendAnnouncementsSeen={sendAnnouncementsSeen}
                humiIsabellaDisabled={humiIsabellaDisabled}
              />
            </div>
          </>
        )}
      </div>
    )
  }
}

AnnouncementsPage.propTypes = {
  announcements: PropTypes.arrayOf(PropTypes.object),
  fetchAnnouncements: PropTypes.func,
  loading: PropTypes.bool,
  onAnnouncementRead: PropTypes.func,
  sendEvent: PropTypes.func,
  onboarding: PropTypes.bool,
  strings: PropTypes.objectOf(PropTypes.string),
  unreadAnnouncements: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  )
}

export default AnnouncementsPage
